<app-launch-field-container [basespaceFormControl]="formControl">
    <hr>
</app-launch-field-container>